export default "__VITE_ASSET__C3UlXe2v__"